export const settingsConfig = {
  searchStatusFilter: [
    {
      label: 'Select Status',
      value: '',
    },
    {
      value: 'APPLICATION_INCOMPLETE',
      label: 'Employer Application Incomplete',
    },
    {
      value: 'INVITED',
      label: 'Applicant Application Incomplete - Invited',
    },
    {
      value: 'ACCEPTED',
      label: 'Applicant Application Incomplete - Accepted',
    },
    {
      value: 'APPLICATION',
      label: 'Applicant Application Incomplete - Application',
    },
    {
      value: 'EXPIRED',
      label: 'Applicant Application Incomplete - Expired',
    },
  ],
  tableHeaders: [
    {
      key: 'Email',
      filterTypes: [
        {
          label: 'Contains',
          type: 'text',
          id: 'email',
        },
        {
          label: 'Equal',
          type: 'text',
          id: 'email',
        },
      ],
    },
    {
      key: 'First Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'firstName',
        },
      ],
    },
    {
      key: 'Last Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'lastName',
        },
      ],
    },
  ],
};
